import * as React from "react";
import MediaQuery from "react-responsive";

import { Button, Container, Icon, Menu, Responsive } from "../semantic-ui";

type Props = {
  brand: React.ReactNode;
  left: React.ReactNode;
  right: React.ReactNode;
};

type State = {
  expanded: boolean;
};

export default class ResponsiveMenu extends React.Component<Props, State> {
  state = { expanded: false };

  render() {
    const { brand, left, right } = this.props;
    const { expanded } = this.state;
    return (
      <MediaQuery minWidth={Responsive.onlyTablet.minWidth}>
        {(matches) =>
          matches ? (
            <Menu attached inverted size="large">
              <Container>
                {brand}
                {left}
                <Menu.Menu position="right">{right}</Menu.Menu>
              </Container>
            </Menu>
          ) : (
            <>
              <Menu attached inverted size="large" fluid>
                {brand}
                <Menu.Item position="right">
                  <Button inverted basic onClick={this.handleToggle}>
                    <Icon name={expanded ? "close" : "bars"} fitted />
                  </Button>
                </Menu.Item>
              </Menu>
              {expanded && (
                <Menu attached inverted vertical fluid>
                  {left}
                  {right}
                </Menu>
              )}
            </>
          )
        }
      </MediaQuery>
    );
  }

  handleToggle = () => {
    this.setState({ expanded: !this.state.expanded });
  };
}
